import * as types from './mutation-type';
const mutations = {
	[types.SET_SELECTOR_INFO](state, paylod) {
		Object.assign(state.selectorInfo, paylod);
	}
};
export default mutations;
